import React, { useState } from 'react';
import { 
    Paper, 
    Typography, 
    TextField, 
    Button, 
    Box,
    Tooltip,
    IconButton
} from '@mui/material';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { useTheme } from '@mui/material/styles';


const QuestionStep = ({ step, onSubmit, loading, businessContext, problemStatement, rawAnswers }) => {
    console.log('QuestionStep props:', { step, problemStatement, businessContext });

    const theme = useTheme();
    const [answer, setAnswer] = useState('');
    const getSampleAnswer = () => {
        const sampleAnswers = [
            "Teachers waste time copying whiteboard notes to share with students",
            "Students miss important information and fall behind in class",
            "Traditional note-taking methods don't adapt to hybrid learning environments",
            "Current digital solutions are expensive and complex to implement",
            "Schools need simple, affordable ways to digitize classroom content"
        ];
        return sampleAnswers[step - 1];
    };

    const loadSampleAnswer = () => {
        setAnswer(getSampleAnswer());
    };

    const getQuestionPrompt = () => {
        console.log('getQuestionPrompt called with:', { step, problemStatement });

        const currentStep = parseInt(step) || 1;
    
        if (currentStep === 1) {
            return (
                <Typography>
                    Why is <Typography component="span" sx={theme.dynamicText.whyStep}>"{problemStatement}"</Typography> a problem? (what happens if it doesn't get solved?)
                </Typography>
            );
        }
        return (
            <Typography>
                Why is <Typography component="span" sx={theme.dynamicText.whyStep}>"{rawAnswers[step-2]}"</Typography> a problem? What happens if it is not addressed?
            </Typography>
        );
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(answer);
        setAnswer('');
    };

    return (
        <Paper sx={{ p: 4, mt: 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6">
                    {getQuestionPrompt()}
                </Typography>
                <Tooltip title="Load Sample Answer">
                    <IconButton onClick={loadSampleAnswer} color="primary">
                        <AutoFixHighIcon />
                    </IconButton>
                </Tooltip>
            </Box>
            
            <form onSubmit={handleSubmit}>
                <TextField
                    fullWidth
                    multiline
                    rows={3}
                    value={answer}
                    onChange={(e) => setAnswer(e.target.value)}
                    placeholder="Enter your answer..."
                    sx={{ mb: 3 }}
                    disabled={loading}
                />
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button 
                        variant="contained" 
                        type="submit"
                        disabled={loading || !answer.trim()}
                    >
                        Continue
                    </Button>
                </Box>
            </form>
        </Paper>
    );
};

export default QuestionStep;
